import { PaymentFailedRestrictionDialog } from '@aibees/elephant/components';
import { SearchBar } from '@aibees/elephant/components/search-bar';
import { useDisplaySearchTable } from '@aibees/elephant/hooks/use-display-search-table';
import { useResetCurrentFilterOnRouteChange } from '@aibees/elephant/hooks/use-reset-current-filter-on-route-change';
import { DashboardLayoutContent } from '@aibees/shared/layouts';
import { Stack } from '@mui/material';
import { SearchResult } from '../../components/search-result';
import * as SX from './sx';

export default function SearchView() {
  const displaySearchTable = useDisplaySearchTable();
  useResetCurrentFilterOnRouteChange();

  return (
    <DashboardLayoutContent
      transparent
      contentSx={SX.content(displaySearchTable)}
    >
      <PaymentFailedRestrictionDialog />
      {displaySearchTable ? (
        <SearchResult />
      ) : (
        <Stack sx={SX.searchBar}>
          <SearchBar />
        </Stack>
      )}
    </DashboardLayoutContent>
  );
}
